module.exports = __webpack_public_path__ + "static/media/Coverphoto-Sidebar.a1ad2c93.jpg";